import React from 'react';
import PropTypes from 'prop-types';

const DialogButtonGroup = ({ children, rounded = true }) => (
  <div className="ws-ui-dialog-button-group" data-rounded={rounded}>
    {children}
  </div>
);

DialogButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  rounded: PropTypes.bool,
};

export default DialogButtonGroup;
